import request from '../../axios';

export const postResendOtpCode = async (bankValidationGuid?: string) => {
  const {data}: {data: {bank_validation: string}} = await request.post(
    `/api/v2/payment/resend-etebarito-otp/bank-validation/` +
      bankValidationGuid,
  );
  return data;
};
